import {
  OnDemandGLAWithLesson,
  StudentYear,
  getLessonLinkBasedOnStudentYear,
  studentYearOption,
} from '@airreading/common/data';

import { useFeatureFlag } from '@/hooks/use-feature-flags';

import { CopyableLink } from '@/components/copyable-link';

interface OnDemandGLALinkProps {
  onDemandGLA: OnDemandGLAWithLesson;
  grade: StudentYear;
  dataTestId?: string;
}

export function OnDemandGLALink({ onDemandGLA, grade, dataTestId }: OnDemandGLALinkProps) {
  const onDemandGLAEnabled = useFeatureFlag('on-demand-gla', false);

  if (!onDemandGLAEnabled) {
    return null;
  }

  const slideLink = getLessonLinkBasedOnStudentYear(onDemandGLA.lesson, grade);

  if (!slideLink) {
    return null;
  }

  return (
    <CopyableLink
      className="text-air-primary"
      externalHref={slideLink}
      canCopyUrl={false}
      showExternalHrefIcon={false}
      data-testid={dataTestId}
    >
      (Needs GLA {studentYearOption(grade)})
    </CopyableLink>
  );
}
